<template>
  <div class="wgtSettings">
    <div class="cardR">
      <div class="boxR">
        <div class="fc myZoomClass" id="waterfallspan">
          <div class="clicker hide-on-presentation">
          </div>
          <div class="modal-content filterHolder mdl mdbox" v-show="settingPopShow && !IswaterErr">
            <div class="modal-header">
              <h5 class="modal-title">Settings</h5>
              <div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close"
                v-on:click="settingPopShow = !settingPopShow;">
                <div class="leftright"></div>
                <div class="rightleft"></div>
              </div>
            </div>
            <div class="container" style="z-index: 1;">
              <div class="row my-3 ">
                <label class="mr15top col-2">
                  Financial Year Zone
                </label>
                <div class="col-10">
                  <input type="radio" id="ist" class="radio me-1" name="zone" value="ist" v-model="zoneIn">
                  <label class="mr15top col-2" for="ist"> Apr - Mar Cycle </label>
                  <input type="radio" id="usa" class="radio me-1" name="zone" value="usa" v-model="zoneIn">
                  <label class="mr15top col-2"> Jan - Dec Cycle </label>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-4">
                  <label class="mr15top">
                    Interval basis
                  </label>
                  <div class="input-group mr15top">
                    <VueMultiselect class="mymultiselect  hide-on-presentation " v-model="intervalOp" selectLabel="" :options="intervalopts"
                      :multiple="false" :allow-empty="false" deselect-label="can't Deselect" :close-on-select="true"
                      @select="changeDataTime" placeholder="Pick" track-by="value" label="display" />
                  </div>
                </div>
                <div class="col-4">
                  <label class="mr15top">
                    From
                  </label>
                  <div class="input-group mr15top">
                    <VueMultiselect class="mymultiselect  hide-on-presentation " v-model="fromValue" selectLabel="" :options="fromValueOpt"
                      :multiple="false" :allow-empty="false" deselect-label="can't Deselect" :close-on-select="true"
                      placeholder="Pick" :show-labels="false" />
                  </div>
                </div>
                <div class="col-4">
                  <label class="mr15top">
                    To
                  </label>
                  <div class="input-group mr15top">
                    <VueMultiselect class="mymultiselect  hide-on-presentation " v-model="toValue" :options="toValueOpt" :multiple="false"
                      :allow-empty="false" deselect-label="can't Deselect" :close-on-select="true" placeholder="Pick"
                      :show-labels="false" selectLabel="" />
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="modal-footer">
                  <div class="effect btn-apply eff-md" v-on:click="getWaterfallChart(changeOp, 1);">
                    Apply
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-panel1" id="changeChartDiv" v-show="!IswaterErr">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IswaterErr">
                  <font-awesome-icon :icon="['fas', 'eye']" title="Show Blank Values" v-on:click="drawWaterFall(1)"
                    v-if="isRemoveBlank" />
                  <font-awesome-icon :icon="['fas', 'eye-slash']" title="Hide Blank Values" v-on:click="drawWaterFall(0)"
                    v-else />
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                    v-on:click="addToSlider()" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.widgetInfo.waterfall_view }} <br />
                <br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-cog" /> to open settings
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" :icon="['fas', 'eye']" /> to see non blank
                    values and
                    <font-awesome-icon class="actIcon" :icon="['fas', 'eye-slash']" /> to see blank
                    values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to
                    add to
                    storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to
                    download the chart
                    with current insight
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!iswaterLoad">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="!iswaterLoad && settingPopShow" class="settingDiv"></div>
            <div class="row">
              <div class="col-1 text-end">
              </div>
              <div class="col-3">
                <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="changeOp" :options="WFfilteron"
                  :multiple="false" :allow-empty="false" deselect-label="can't Deselect" :close-on-select="true"
                  @select="getWaterfallChart" placeholder="Pick" track-by="name" label="name" selectLabel="" />
              </div>
              <div class="col-6">
                <h4 class="text-start">From {{ fromValue }} - to {{ toValue }}</h4>
              </div>
              <div class="col-2 text-start">
                <font-awesome-icon class="myfaBtn cursor-pointer hide-on-presentation" icon="fa-solid fa-cog"
                  title="Open Settings" v-on:click="settingPopShow = !settingPopShow;" />
              </div>
            </div>
            <div class="content-panel1" v-show="IswaterErr || iswaterData">
              <apiErrorComponent @tryReload="tryReload" compTitle="" compId="waterfallspan">
              </apiErrorComponent>
            </div>
            <div v-show="!iswaterData">
              <div class="panel-body text-center" style="height: 800px;">
                <div id="waterfallChartHdr" style="height: 800px">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import domtoimage from "dom-to-image-more";
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue'
import {
  saveAs
} from 'file-saver';
var wholewaterdata = {};
var waterFallFltr;
var myWaterFallChart;
function reportWindowSizeWFC() {
  if (myWaterFallChart != undefined) {
    myWaterFallChart.resize()
  }
}
export default {
  name: 'waterFall',
  mixins: [screenShotMix],
  props: {
    getpass: Object,
    getPins: Object,
    tabname: String,
  },
  components: {
    widgetLoadingComp,
    apiErrorComponent
  },
  data() {
    return {
      changeOp: this.getpass.changeOp[0],
      WFfilteron: this.getpass.WFfilteron,
      iswaterData: false,
      IswaterErr: false,
      iswaterLoad: false,
      iswaterShw: false,
      intervalOp: {},
      interYropts: [],
      zoneIn: "",
      intervalYr_Start: {},
      intervalYr_End: {},
      intervalYr_Stopts: [],
      yearPer: "",
      yearops: [],
      settingPopShow: false,
      intervalopts: [],
      isYrShow: true,
      isRemoveBlank: null,
      durationType: "",
      fromValue: "",
      fromValueOpt: [],
      toValue: "",
      toValueOpt: [],
      allYears: [],
      myColorArray: [],
      myBorderArray: [],
      screenShort: {
        id: 'waterfallspan',
        name: 'waterfallspan.png'
      }
    }
  },
  methods: {
    tryReload() {
      let chkFilterOn = this.WFfilteron.find(element => element.ticked == true)
      if (chkFilterOn != undefined && chkFilterOn.name == this.changeOp.name) {
        this.getWaterfallChart(this.changeOp, 0)
      } else {
        this.getWaterfallChart(chkFilterOn, 1)
      }
    },
    addToSlider() {
      let insArr = [];
      let name = "Waterfall - " + this.getPins.viewName;
      let screenShort = {
        id: 'waterfallspan',
        name: 'waterfallspan.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    changeDataTime(val, id) {
      this.changeFromTo(val)
    },
    changeFromTo(interval) {
      this.durationType = interval.value
      switch (interval.value) {
        case 'Qtr':
          this.fromValueOpt = interval.Quarters
          this.toValueOpt = interval.Quarters
          this.fromValue = interval.Quarters[0]
          this.toValue = interval.Quarters[1]
          break;
        case 'mon':
          this.fromValueOpt = interval.Months
          this.toValueOpt = interval.Months
          this.fromValue = interval.Months[0]
          this.toValue = interval.Months[1]
          break;
        case 'Bi':
          this.fromValueOpt = interval.Semester
          this.toValueOpt = interval.Semester
          this.fromValue = interval.Semester[0]
          this.toValue = interval.Semester[1]
          break;
        case 'yoy':
          this.fromValueOpt = interval.Years
          this.toValueOpt = interval.Years
          this.fromValue = interval.Years[0]
          this.toValue = interval.Years[1]
          break;
        default:
      }
    },
    drawWaterFall(val, yearpos) {
      var data = []
      var Blank_data = []
      var nonblank_data = []
      this.iswaterData = false
      this.iswaterShw = true
      if (wholewaterdata[0].status == "Nodata" && yearpos == "initial") {
        this.iswaterData = true
        this.iswaterShw = true
      } else if (yearpos != undefined && yearpos != "initial" && wholewaterdata[yearpos[0].dbpos].status ==
        "Nodata") {
        this.iswaterData = true
        this.iswaterShw = true
      } else {
        if (yearpos != undefined && yearpos != "initial") {
          yearpos = yearpos[0].dbpos
          Blank_data = wholewaterdata[yearpos].Blank_data
          nonblank_data = wholewaterdata[yearpos].nonblank_data
        } else {
          Blank_data = wholewaterdata[0].Blank_data
          nonblank_data = wholewaterdata[0].nonblank_data
          yearpos = 0
        }
        if (val == 0) {
          data = Object.assign([], Blank_data)
          this.isRemoveBlank = true
        } else {
          data = Object.assign([], nonblank_data)
          this.isRemoveBlank = false
        }
        var chartDom = document.getElementById('waterfallChartHdr');
        if(chartDom == null) return;
        if (chartDom != null && chartDom != undefined) {
          if (myWaterFallChart != null || myWaterFallChart != undefined) {
            echarts.dispose(myWaterFallChart)
          }
          myWaterFallChart = echarts.init(chartDom, null, {
            renderer: 'svg'
          });
          var option;
          let blankArr = []
          let endArr = []
          let labelArr = []
          let positiveArr = []
          let negativeArr = []
          let counter = 0
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            labelArr.push(element.name)
            if (index == 0) {
              counter += element.value;
              blankArr.push('-')
              endArr.push(counter)
            } else {
              if (element.value > 0) {
                blankArr.push(counter)
                endArr.push('-')
                counter += element.value;
              } else {
                counter += element.value;
                blankArr.push(counter)
                endArr.push('-')
              }
            }
            if (index == 0) {
              positiveArr.push('-')
              negativeArr.push('-')
            } else {
              if (element.value > 0) {
                positiveArr.push(element.value)
                negativeArr.push('-')
              } else {
                positiveArr.push('-')
                negativeArr.push(-element.value)
              }
            }
          }
          labelArr.push(wholewaterdata[yearpos].toMonth)
          blankArr.push('-')
          positiveArr.push('-')
          negativeArr.push('-')
          endArr.push(counter)
          option = {
            tooltip: {
              confine: true,
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              },
              formatter: function (params) {
                let tar;
                if (params[1].data != '-') {
                  tar = params[1].data;
                } else if (params[2].data != '-') {
                  tar = params[2].data;
                }
                if (params[3].data != '-') {
                  tar = -params[3].data;
                }
                return params[0].name + ": " + tar + " tickets";
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: labelArr,
              axisLabel: {
                rotate: 30,
                overflow: 'break',
                color: '#52aab1'
              }
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                color: '#52aab1'
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: true
              }
            },
            series: [{
              name: 'Placeholder',
              type: 'bar',
              stack: 'Total',
              silent: true,
              itemStyle: {
                borderColor: 'transparent',
                color: 'transparent'
              },
              emphasis: {
                itemStyle: {
                  borderColor: 'transparent',
                  color: 'transparent'
                }
              },
              data: blankArr
            },
            {
              name: 'Ticket Count',
              type: 'bar',
              stack: 'Total',
              label: {
                show: true,
                position: 'top'
              },
              itemStyle: {
                borderRadius: 2,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(30,120,149,0.75)'
                },
                {
                  offset: 1,
                  color: 'rgba(30,120,149,0.25)'
                }
                ]),
                borderColor: '#1e7895',
                borderWidth: 1,
                opacity: 1,
              },
              data: endArr
            },
            {
              name: 'positive',
              type: 'bar',
              stack: 'Total',
              label: {
                show: true,
                position: 'bottom'
              },
              itemStyle: {
                borderRadius: 2,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(0,99,0,0.75)'
                },
                {
                  offset: 1,
                  color: 'rgba(0,99,0,0.25)'
                }
                ]),
                borderColor: '#006300',
                borderWidth: 1,
                opacity: 1
              },
              data: positiveArr
            },
            {
              name: 'negative',
              type: 'bar',
              stack: 'Total',
              label: {
                show: true,
                position: 'bottom'
              },
              itemStyle: {
                borderRadius: 2,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(233,55,55,0.75)'
                },
                {
                  offset: 1,
                  color: 'rgba(233,55,55,0.25)'
                }
                ]),
                borderColor: '#bf444c',
                borderWidth: 1,
                opacity: 1
              },
              data: negativeArr
            }
            ]
          };
          option && myWaterFallChart.setOption(option);
        }
      }
    },
    loadYearEnd(catop) {
      var start_yr = []
      for (var i = 0; i < this.interYropts.length; i++) {
        start_yr.push({
          value: this.interYropts[i].value,
        })
      }
      if (catop != undefined) {
        this.interYrEndopts = start_yr
        var pos = -1
        for (var j = 0; j < this.interYrEndopts.length; j++) {
          if (this.interYrEndopts[j].value === catop) {
            pos = j
            break
          }
        }
        var position = pos
        if (position > -1 && position == 0) {
          this.interYrEndopts.splice(position, 1)
        } else if (position > -1) {
          this.interYrEndopts.splice(0, position + 1)
        } else {
          this.interYrEndopts = catop
        }
        this.intervalYr_End = this.interYrEndopts[0].value
      }
    },
    getWaterfallChart(changeOp, mode) {
      waterFallFltr = {}
      this.iswaterData = false
      this.IswaterErr = false
      this.iswaterLoad = false
      this.iswaterShw = false
      if (changeOp != "") {
        changeOp = changeOp.dbname
      }
      if (mode == 0) {
        waterFallFltr = {
          "filterlevel": changeOp,
          "selid": this.getPins.selid,
          "edited": this.getPins.edited
        }
      } else {
        waterFallFltr = {
          "filterlevel": changeOp,
          "zoneIn": this.zoneIn,
          "selid": this.getPins.selid,
          "edited": this.getPins.edited,
          "intervalOp": this.durationType,
          "intervalVal": {
            "from": this.fromValue,
            "to": this.toValue
          }
        }
      }
      if ((this.fromValue != this.toValue) || (this.fromValue == "" && this.toValue == "")) {
        this.axios.post(this.uriApiUrl + 'DataAnalysis/waterfall_view?asg_id=' + this.asgId + "&mode=" + mode,
          waterFallFltr,{
      headers: {
            'Content-Type': 'application/json'
          }}
        )
          .then((response) => {
            if (response.status == 200) {
              if (response.data != "Error" && response.data != "Nodata") {
                var wholewfData = response.data
                wholewaterdata = wholewfData.MonthData
                if (wholewaterdata.length != 0) {
                  this.isYrShow = false
                  this.yearops = wholewfData.yearops
                  this.intervalopts = wholewfData.intervalopts
                  this.interYropts = wholewfData.intervalOp
                }
                this.iswaterShw = true
                this.zoneIn = wholewfData.zoneIn
                this.intervalopts = wholewfData.intervalopts
                this.interYropts = wholewfData.intervalOp
                if (this.interYropts.length > 2) {
                  this.intervalYr_Stopts = this.interYropts
                  this.intervalYr_Stopts.splice(-1, 1)
                  this.intervalYr_Start = this.interYropts[0].value
                  this.loadYearEnd(this.interYropts[0].value)
                }
                this.allYears = wholewfData.intervalOp
                let defalutData = wholewfData.init_range
                let sparatData = defalutData.split(',')
                this.intervalOp = this.intervalopts.find(el => el.value === sparatData[0])
                this.changeFromTo(this.intervalOp)
                this.fromValue = sparatData[1]
                this.toValue = sparatData[2]
                this.intervalYr = wholewfData.interYrIn
                if (mode == 1) {
                  this.settingPopShow = !this.settingPopShow
                }
                setTimeout(() => {
                  this.drawWaterFall(0, "initial")
                }, 5)
              } else if (response.data == "Nodata") {
                this.iswaterData = true
              } else {
                this.IswaterErr = true
                this.$notify({
                  type: "error",
                  text: 'Sorry! Something went wrong in Waterfall view. Try after sometime!'
                })
              }
              this.iswaterLoad = true
            }
          }).catch((response) => {
            this.IswaterErr = true
            this.iswaterLoad = false
            if (this.enabledDebug == 1) {
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Waterfall view. Try after sometime!'
              })
            }
          })
      } else {
        this.iswaterLoad = true
        this.$notify({
          type: "error",
          text: 'Sorry! From and To filters cannot have same values !',
          duration: 3000
        })
      }
    },
    downloadDom() {
      let imgname = "WaterFall_Chart.png"
      let widgetID = "waterfallspan"
      var geticondiv = document.querySelectorAll('#waterfallspan .insideL,#waterfallspan .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    let chkFilterOn = this.WFfilteron.find(element => element.ticked == true)
    if (chkFilterOn != undefined && chkFilterOn.name == this.changeOp.name) {
      this.getWaterfallChart(this.changeOp, 0)
    } else {
      this.getWaterfallChart(chkFilterOn, 1)
    }
    this.myColorArray = [new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(253, 55, 56, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(253, 55, 56, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(247, 99, 12, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(247, 99, 12, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(255, 185, 0, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(255, 185, 0, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(75, 192, 192, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(75, 192, 192, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(54, 162, 235, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(54, 162, 235, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(136,23,152, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(136,23,152, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(168, 192, 255, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(168, 192, 255, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(255, 216, 155, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(255, 216, 155, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(178, 159, 148, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(178, 159, 148, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(54, 191, 54, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(54, 191, 54, 0.25)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(75, 19, 79, 0.75)'
    }, {
      offset: 1,
      color: 'rgba(75, 19, 79, 0.25)'
    }]),
    ]
    this.myBorderArray = ['rgba(253, 55, 56, 0.9)',
      'rgba(247, 99, 12, 0.9)',
      'rgba(255, 185, 0, 0.9)',
      'rgba(75, 192, 192, 0.9)',
      'rgba(54, 162, 235, 0.9)',
      'rgba(136,23,152, 0.9)',
      'rgba(168, 192, 255,0.9)',
      'rgba(255, 216, 155,0.9)',
      'rgba(178, 159, 148, 0.9)',
      'rgba(54, 191,54,0.9)',
      'rgba(75, 19, 79, 0.75)'
    ]
    window.addEventListener("resize", reportWindowSizeWFC);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeWFC);
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.settingsRw {
  margin: 30px 0;
  width: 98%;
}

.bar text {
  fill: white;
  font: 12px sans-serif;
  text-anchor: middle;
}

.axis text {
  font: 10px sans-serif;
}

.wgtSettings {
  min-height: 500px;
}

.wgtSettings .cardR {
  min-height: 500px;
  width: 100%;
}

.wgtSettings .cardR .content-panel1 {
  height: 870px;
  padding: 16px 8px 40px 8px;
}

.wgtSettings .cardR .popup-model {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.filterHolder {
  z-index: 30;
  width: 80%;
  left: 10%;
  top: 35px;
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>